import React from "react";

const Commontext = (props) => {
  return <p>{props.name}</p>;
};

export default Commontext;
